import { Profile } from "./profile";

export class Profiles {

    public nom: string;

    public prenom: string;

    public mail: string;

    public profiles: Array<Profile>;

    public getDefaultProfile(): Profile {
        if (this.profiles === null || this.profiles.length === 0) {
            throw new Error("No authorized profile.")
        }
        return Profile.min(this.profiles)
    }
}